export default "__VITE_ASSET__BTnEbs7v__"